import { render } from "./Imgix.vue?vue&type=template&id=724a55ce&ts=true&lang=pug"
import script from "./Imgix.vue?vue&type=script&lang=ts"
export * from "./Imgix.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__